"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ArrowUp, Facebook, Instagram, Mail, MapPin, Phone, Star } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="208693" className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/" className="text-foreground/70 hover:text-primary transition-colors font-sans text-xs md:text-sm">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors font-sans text-xs md:text-sm">
            Dining
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors font-sans text-xs md:text-sm">
            Desert Tours
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/70 hover:text-primary transition-colors font-sans text-xs md:text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground relative border-t border-primary/20">
      <div className="h-px w-full bg-primary/20" aria-hidden="true" />

      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16 lg:py-20 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 md:gap-12">
          
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-xs md:text-sm font-bold tracking-widest uppercase text-foreground">
              Explore
            </h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col items-start gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633409/img/arstv_media_logo_dark.png" alt="The One Oman" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-foreground/60 leading-relaxed max-w-xs text-xs md:text-sm font-sans">The One Oman Private Camps offers luxury private desert stays in Wahiba Sands, Oman. Experience complete privacy, comfort, and authentic Omani desert heritage.</p>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-xs md:text-sm font-bold tracking-widest uppercase text-foreground">
              Contact
            </h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3 text-foreground/70">
                <Phone className="size-4 md:size-5 text-primary shrink-0" />
                <span className="text-xs md:text-sm font-sans">+968 7285008</span>
              </div>
              <div className="flex items-center gap-3 text-foreground/70">
                <Phone className="size-4 md:size-5 text-primary shrink-0" />
                <span className="text-xs md:text-sm font-sans">+968 77631616</span>
              </div>
              <div className="flex items-center gap-3 text-foreground/70">
                <Mail className="size-4 md:size-5 text-primary shrink-0" />
                <span className="text-xs md:text-sm font-sans">theonecampsoman@gmail.com</span>
              </div>
              <Link to="https://maps.google.com" className="text-foreground/70 hover:text-primary transition-colors inline-flex">
                <MapPin className="size-4 md:size-5 text-primary shrink-0" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-xs md:text-sm font-bold tracking-widest uppercase text-foreground">
              Follow Us
            </h3>
            <div className="flex items-center gap-4">
              <Link to="https://instagram.com" newTab className="text-foreground/70 hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-4 md:size-5 text-primary" />
              </Link>
              <Link to="https://facebook.com" newTab className="text-foreground/70 hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-4 md:size-5 text-primary" />
              </Link>
              <Link to="https://tripadvisor.com" newTab className="text-foreground/70 hover:text-primary transition-colors" aria-label="TripAdvisor Reviews">
                <Star className="size-4 md:size-5 text-primary" />
              </Link>
              <Link to="https://maps.google.com" newTab className="text-foreground/70 hover:text-primary transition-colors" aria-label="Google Maps Reviews">
                <MapPin className="size-4 md:size-5 text-primary" />
              </Link>
            </div>
          </div>

        </div>

        <div className="mt-12 md:mt-20 flex flex-col items-center justify-between gap-4 border-t border-primary/20 pt-6 md:pt-10 sm:flex-row">
          <p className="text-[10px] sm:text-xs text-foreground/60 text-center sm:text-left font-sans tracking-wide">
            &copy; {currentYear} The One Oman Private Camps. Handcrafted in Oman.
          </p>
          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-full border-primary/20 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-500" aria-label="Scroll to top">
            <ArrowUp className="size-4 md:size-5 text-primary" />
          </Button>
        </div>
      </div>
    </section>;
}